module.exports = __webpack_public_path__ + "static/media/delete.edccec0c.png";